<template>
	<div>
    	<div v-if="loadingRoles">
			<preloader></preloader>
		</div>

		<div class="fixed-action-btn">
		    <a 
		    	href="#" 
		    	class="btn btn-success btn-floating btn-large" 
		    	title="Agregar rol"  
		    	v-on:click.prevent="openModalRoles">
		        <i class="material-icons">note_add</i>
		    </a>
		</div>

		<div :class="{'table-responsive':true, 'position-relative':loadingRoles}" v-if="roles.data.length>0">
			<div class="table-loading" v-if="loadingRoles">
				<div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
					<span class="sr-only">Cargando...</span>
				</div>
				<h5 class="m-0">Cargando..</h5>
			</div>
            <table v-bind:class="{'table table-borderless table-hover table-striped':true, 'table-sm':compacta}">
                <thead>
                    <tr>
                    	<th>Código</th>
                    	<th>Nombre</th>
                    	<th>Descripción</th>
                    	<th>Especial</th>
                    	<th width="190">
                    		<div class="custom-control custom-switch">
								<input type="checkbox" class="custom-control-input" id="compactaRoles" v-model="compacta">
								<label class="custom-control-label" for="compactaRoles">Compacta</label>
							</div>
                    	</th>
                    </tr>
                </thead>
                <tbody>
                	<tr v-for="rol in roles.data">
                		<th>{{rol.CODIGO}}</th>
	            		<th>{{rol.NOMBRE}}</th>
	                   	<th>{{rol.DESCRIPCION}}</th>
	                   	<td>{{rol.ESPECIAL}}</td>
	                   	<td>
	                   		<div class="btn-group text-right table-hover-options">
	                   			<a 
	                   				v-if="false"
		                        	href="#" 
		                        	class="text-muted ml-2 p-1" 
		                        	v-tooltip="'Ver rol'" 
		                        	v-on:click.prevent="showRol(rol)">
		                            <i class="material-icons">search</i>
		                        </a>
		                   		<a 
		                        	href="#" 
		                        	class="text-muted ml-2 p-1" 
		                        	v-tooltip="'Editar rol'" 
		                        	v-on:click.prevent="editRol(rol)"
		                        	v-if="roleUser() != 'V'">
		                            <i class="material-icons">edit</i>
		                        </a>
		                        <a 
		                        	href="#" 
		                        	class="text-muted ml-2 p-1" 
		                        	v-tooltip="'Eliminar rol'" 
		                        	v-on:click.prevent="deleteRol(rol)"
		                        	v-if="roleUser() != 'V'">
		                            <i class="material-icons">delete</i>
		                        </a>
	                   		</div>
	                   	</td>
	                </tr>
                </tbody>
            </table>
		</div>
		<div v-else>
			<empty icon="hourglass_empty" title="No hay información." description="No hay información relacionada a los roles.">
			</empty>
		</div>
		<paginacion 
			:pagination="roles"
            @paginate="getRoles()"
            :offset="4">
        </paginacion>

        <div class="modal fade" id="modalRol" role="dialog" aria-labelledby="modal-oportunidadLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-dialog-scrollable" role="document">
			    <div class="modal-content">
			      	<div class="modal-header">
			        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modalRol=='create'">
			        		Registrar rol
			        	</h5>
			        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modalRol=='edit'">
			        		Actualizar rol
			        	</h5>
			        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modalRol=='show'">
			        		rol {{rol.codigo}}
			        	</h5>
			    	</div>
			    	<div class="modal-body py-0">
			    		<div v-if="modalRol=='show'">
				    		<ul class="nav nav-tabs" id="rol" role="tablist">
								<li class="nav-item">
									<a class="nav-link active" id="info-tab" data-toggle="tab" href="#info" role="tab" aria-controls="info" aria-selected="true">
										Información
									</a>
								</li>
								<li class="nav-item">
									<a class="nav-link active" id="permisos-tab" data-toggle="tab" href="#permisos" role="tab" aria-controls="permisos" aria-selected="true">
										Permisos
									</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
										Auditoría
									</a>
								</li>
							</ul>
							<div class="tab-content" id="rolContent">
	  							<div class="tab-pane fade show active" id="info" role="tabpanel" aria-labelledby="info-tab">
	  								<div class="form-row">
						    			<div class="col-md-12 form-group">
						    				<label>
						    					Nombre:
						    				</label>
						    				{{rol.nombre}}
						    			</div>

						    			<div class="col-md-12 form-group">
						    				<label>
						    					SLUG:
						    				</label>
						    				{{rol.slug}}
						    			</div>

						    			<div class="col-md-12 form-group">
						    				<label>
						    					Descripción:
						    				</label>
						    				{{rol.descripcion}}
						    			</div>

						    			<div class="col-md-12 form-group">
						    				<label>
						    					Especial:
						    				</label>
						    				{{rol.especial}}
						    			</div>
						    		</div>
	  							</div>
	  							<div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
	  								<div class="row py-3">
										<div class="col-md-6 mb-3">
											<div class="media">
												<div class="align-self-center mr-3" v-tooltip="'Creado Por'">
													<i class="material-icons">person_add</i>
												</div>
												<div class="media-body">
													<label>Creado Por:</label>
													<p class="m-0">
														{{rol.creado_por.codigo}} - {{rol.creado_por.nombre}}
													</p>
												</div>
											</div>
										</div>
										<div class="col-md-6 mb-3">
											<div class="media">
												<div class="align-self-center mr-3" v-tooltip="'Actualizado Por'">
													<i class="material-icons">person_outline</i>
												</div>
												<div class="media-body">
													<label>Actualizado Por:</label>
													<p class="m-0">
														{{rol.actualizado_por.codigo}} - {{rol.actualizado_por.nombre}}
													</p>
												</div>
											</div>
										</div>
										<div class="col-md-6 mb-3">
											<div class="media">
												<div class="align-self-center mr-3" v-tooltip="'Fecha Creación'">
													<i class="material-icons">access_time</i>
												</div>
												<div class="media-body">
													<label>Fecha Creación:</label>
													<p class="m-0">
														{{rol.fecha_creacion}}
													</p>
												</div>
											</div>
										</div>
										<div class="col-md-6 mb-3">
											<div class="media">
												<div class="align-self-center mr-3" v-tooltip="'Fecha Actualización'">
													<i class="material-icons">update</i>
												</div>
												<div class="media-body">
													<label>Fecha Actualización:</label>
													<p class="m-0">
														{{rol.fecha_actualizacion}}
													</p>
												</div>
											</div>
										</div>
										<div class="col-md-6 mb-3">
											<div class="media">
												<div class="align-self-center mr-3" v-tooltip="'Creado Desde'">
													<i class="material-icons">add_location</i>
												</div>
												<div class="media-body">
													<label>Creado Desde:</label>
													<p class="m-0">
														{{rol.creado_desde}}
													</p>
												</div>
											</div>
										</div>
										<div class="col-md-6 mb-3">
											<div class="media">
												<div class="align-self-center mr-3" v-tooltip="'Actualizado Desde'">
													<i class="material-icons">edit_location</i>
												</div>
												<div class="media-body">
													<label>Actualizado Desde:</label>
													<p class="m-0">
														{{rol.actualizado_desde}}
													</p>
												</div>
											</div>
										</div>
									</div>
	  							</div>
							</div>
			    		</div>

						<div class="form-row" v-else>
			    			<div class="col-md-12 form-group">
			    				<label>
			    					Nombre:
			    				</label>
			    				<input
			    					class="form-control form-control-sm"
			    					v-model="rol.nombre"
			    					maxLength="255">
			    				<div v-if="errors && errors.nombre" class="text-danger">
			                        {{ errors.nombre[0] }}
			                    </div>
			    			</div>

			    			<div class="col-md-12 form-group">
			    				<label>
			    					SLUG:
			    				</label>
			    				<input
			    					class="form-control form-control-sm"
			    					v-model="rol.slug"
			    					maxLength="255">
			    				<div v-if="errors && errors.slug" class="text-danger">
			                        {{ errors.slug[0] }}
			                    </div>
			    			</div>

			    			<div class="col-md-12 form-group">
			    				<label>
			    					Descripción:
			    				</label>
			    				<textarea 
			    					v-model="rol.descripcion"
			    					class="form-control"
			    					maxlength="255"></textarea>
			    				<div v-if="errors && errors.descripcion" class="text-danger">
			                        {{ errors.descripcion[0] }}
			                    </div>
			    			</div>

			    			<div class="col-md-12 form-group">
			    				<label>Especial:</label>
			    				<div class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="no-access" name="especial" class="custom-control-input" value="no-access" v-model="rol.especial">
									<label class="custom-control-label" for="no-access">no-access</label>
								</div>
								<div class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="all-access" name="especial" class="custom-control-input" value="all-access" v-model="rol.especial">
									<label class="custom-control-label" for="all-access">all-access</label>
								</div>
								<div class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="no-defined" name="especial" class="custom-control-input" value="" v-model="rol.especial">
									<label class="custom-control-label" for="no-defined">no definido</label>
								</div>
			    			</div>
			    		</div>
			    	</div>
			    	<div class="modal-footer">
			    		<button 
			    			type="button" 
			    			class="btn btn-secondary" 
			    			:disabled="loadingRolStore"
			    			v-on:click.prevent="closeModalRol">
			    			Cancelar
			    		</button>

			    		<button 
			    			type="button" 
			    			class="btn btn-secondary"
			    			:disabled="loadingRolStore" 
			    			v-if="modalRol=='create'"
			    			v-on:click.prevent="storeRol">
			    			Crear
			    		</button>

			    		<button 
			    			type="button" 
			    			class="btn btn-secondary"
			    			:disabled="loadingRolStore" 
			    			v-if="modalRol=='edit'"
			    			v-on:click.prevent="updateRole">
			    			Actualizar
			    		</button>
			    	</div>
			    </div>
			</div>
		</div>
    </div>
</template>
<script>
	export default{
		props: ['requerimiento'],

		data(){
			return {
				compacta: false,
				roles: {
		            total: 0,
		            per_page: '',
		            data: [],
		            from: 1,
		            to: 0,
		            current_page: 1
		        },

				loadingRoles: false,

				loadingRoles: false,
				loadingRolStore: false,

				modalRol: 'create',
				rol: {
					codigo: '',
					nombre: '',
					slug: '',
					descripcion: '',
					especial: '',

					fecha_creacion: '',
					fecha_actualizacion: '',
					creado_desde: '',
					actualizado_desde: '',
					creado_por: {
						codigo: '',
						nombre: '',
					},
					actualizado_por: {
						codigo: '',
						nombre: '',
					},

					permisos: []
				},
				errors: {},
			}
		},

		mounted(){
			this.getRoles()

			var vm = this;
			$.fn.getRoles = function (options) {
				vm.getRoles();
			};
		},

		methods: {
			getRoles: function(validatePage = false){
				this.loadingRoles = true
				if (validatePage) {
					this.roles.current_page = 1
				}

				axios.get(`api/roles/paginate?page=${this.roles.current_page}&per_page=${this.roles.per_page}`)
				.then(response => {
					this.roles = response.data
				}).catch(error => {
					console.log(error.response)
				}).then(()=>{
					this.loadingRoles = false
				})
			},

			addRol: function(){
				this.cleanFieldsRoles();
				this.openModalRoles();
			},

			storeRol: function(){
				this.loadingRolStore = true;
				var url = 'api/roles';

				axios.post(url, {
					nombre: this.rol.nombre,
					slug: this.rol.slug,
					descripcion: this.rol.descripcion,
					especial: this.rol.especial,
					permisos: this.rol.permisos,
				})
				.then(response => {
					this.getRoles();
					this.$toasted.show('El rol ha sido registrado.');
					this.closeModalRol();
				}).catch(error => {
					console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al registrar rol.');
				}).then(()=>{
					this.loadingRolStore = false;
				});
			},

			showRol: function(data){
				this.modalRol = 'show';
				
				this.rol.codigo = data.CODIGO;
				this.rol.nombre = data.NOMBRE;
				this.rol.slug = data.SLUG;
				this.rol.descripcion = data.DESCRIPCION;
				this.rol.especial = data.ESPECIAL;
				
				this.rol.fecha_creacion = data.FECHA_CREACION;
				this.rol.fecha_actualizacion = data.FECHA_ACTUALIZACION;
				this.rol.creado_desde = data.CREADO_DESDE;
				this.rol.actualizado_desde = data.ACTUALIZADO_DESDE;
				if (data.creado_por) {
					this.rol.creado_por.codigo = data.creado_por.CODIGO_USUARIO;
					this.rol.creado_por.nombre = data.creado_por.NOMBRE;
				}

				if (data.actualizado_por) {
					this.rol.actualizado_por.codigo = data.actualizado_por.CODIGO_USUARIO;
					this.rol.actualizado_por.nombre = data.actualizado_por.NOMBRE;
				}

				this.openModalRoles();
			},

			editRol: function(data){
				this.modalRol = 'edit';
				this.rol.codigo = data.CODIGO;
				this.rol.nombre = data.NOMBRE;
				this.rol.slug = data.SLUG;
				this.rol.descripcion = data.DESCRIPCION;
				this.rol.especial = data.ESPECIAL;

				this.openModalRoles();
			},

			updateRole: function(){
				this.loadingRolStore = true;
				this.errors = {};
				
				var url = 'api/roles/'+this.rol.codigo;

				axios.put(url, {
					nombre: this.rol.nombre,
					slug: this.rol.slug,
					descripcion: this.rol.descripcion,
					especial: this.rol.especial,
					permisos: this.rol.permisos,
				})
				.then(response => {
					this.getRoles();
					this.$toasted.show('El rol ha sido actualizado.');
					this.closeModalRol();
				}).catch(error => {
					console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al actualizar rol.');
				}).then(()=>{
					this.loadingRolStore = false;
				});
			},

			deleteRol: function(data){
				var url = 'api/roles/'+data.CODIGO;
				var modules = this;

				$.confirm({
			        title: '¿Estás seguro?',
			        content: '¡Ya no podrás recuperar esta información!',
			        theme: 'supervan', // 'material', 'bootstrap'
			        buttons: {
			            Confirmar: function () {
			                axios.delete(url)
			                    .then(response => {
			                    	modules.getRoles();
			                        modules.$toasted.show('Eliminado');
			                    })
			                    .catch(error => {
			                        modules.$toasted.show('Error al Eliminar');
			                        console.log(error);
			                        console.log(error.response);
			                    });
			            },
			            Cancelar: function () {
			            },
			        }
			    });
			},

			openModalRoles: function(){
				$('#modalRol').modal('show');
			},

			closeModalRol: function(){
				$('#modalRol').modal('hide');
			},

			cleanFieldsRoles: function(){
				this.modalRol = 'create';
				this.rol.nombre = '';
				this.rol.slug = '';
				this.rol.descripcion = '';
				this.rol.especial = '';
				this.rol.permisos = [];
			},
		},

		computed: {
			requerimientoFilter: function(){
				return this.requerimiento
			}
		},

		watch: {
			requerimientoFilter: function(val, oldVal){
				if (oldVal == val) {
					return
				}
				this.getRoles(true)
			}
		}
	}
</script>